import { useLocation, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

// Hide on home + routes that already have their own back/nav affordance
const HIDDEN_EXACT = ['/', '/home'];
const HIDDEN_PREFIXES = ['/admin', '/login', '/register', '/forgot-password', '/reset-password', '/unsubscribed'];

/**
 * A soft floating "back" arrow in the top-left of every non-home page.
 * Tapping it navigates back one step in history; if history is empty
 * (e.g. the visitor landed directly on this URL), it goes to Home.
 */
export default function FloatingBackButton() {
  const navigate = useNavigate();
  const location = useLocation();

  const exactHidden = HIDDEN_EXACT.includes(location.pathname);
  const prefixHidden = HIDDEN_PREFIXES.some((p) => location.pathname === p || location.pathname.startsWith(p + '/'));
  if (exactHidden || prefixHidden) return null;

  const goBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate('/');
    }
  };

  return (
    <button
      onClick={goBack}
      aria-label="Go back"
      data-testid="floating-back-btn"
      className="fixed z-40 rounded-full transition-all duration-300 hover:-translate-x-0.5 hover:scale-105 inline-flex items-center justify-center"
      style={{
        top: '82px',
        left: '20px',
        width: '42px',
        height: '42px',
        backgroundColor: 'rgba(253,251,247,0.92)',
        color: '#2C2A29',
        border: '1px solid #E6E2D8',
        boxShadow: '0 6px 20px rgba(0,0,0,0.08), inset 0 1px 0 rgba(255,255,255,0.6)',
        backdropFilter: 'blur(8px)',
      }}
    >
      <ArrowLeft className="w-5 h-5" strokeWidth={2.2} />
    </button>
  );
}
